import { Lightning, Utils } from '@lightningjs/sdk'

export default class PlayerBackButton extends Lightning.Component {
  static _template() {
    return {
      ButnWrapper: {
        w: 59,
        h: 59,
        ButnIcon: { w: 59, h: 59, src: Utils.asset('/images/buttons/BackCross.png') },
      },
    }
  }
}
